
export default {
    computed: {
        /**
         * 单据状态
         *
         */
        getStatus() {
            return [{
                label: this.$t('fbb.inbound.draft', { defaultValue: '草稿' }),
                value: '0',
            },  {
                label: this.$t('global.common.finished', { defaultValue: '已完成' }),
                value: '70',
                theme: 'success'
            }, {
                label: this.$t('global.common.canceled', { defaultValue: '已取消' }),
                value: '90',
                theme: 'error'
            }]
        },
         /**
         * 来源类型
         */
        getOrderType() {
            return [
                { value: 1, label: this.$t('', { defaultValue: '销售退货' }) },
                { value: 2, label: this.$t('', { defaultValue: '调拨入库' }) },
                { value: 3, label: this.$t('', { defaultValue: '一般入库' }) },
            ]
        },
        getInventoryType() {
            return [
                { value: 0, label: this.$t('fbb.inbound.available_stock', { defaultValue: '可售库存' }) },
                { value: 1, label: this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' }) },
            ]
        },
      
    }
}
